import React from 'react';
import DesignOptionFilterForm from '../DesignOptionFilterForm';
import enhance from './enhance';

const ColorLinesOptionFilters = ({
  options,
  colorLinesFormPlaceHolder,
  setActiveFilters,
  activeFilters,
  clearFilter,
}) => {
  return (
    <DesignOptionFilterForm
      options={options}
      placeHolder={colorLinesFormPlaceHolder}
      setActiveFilters={setActiveFilters}
      filterName="colorLineOption"
      activeFilters={activeFilters}
      clearFilter={clearFilter}
    />
  );
};

export default enhance(ColorLinesOptionFilters);
